{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "f974f6adf14682711e389a4132a28486c8f3c0bf",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Wed Nov 4 10:35:12 2026 +0100",
  "VersionNumber": "21979"
}